import { Modal, Space } from "antd";
import { useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { StyledButton } from "~Common/Components";
import PermissionCheck from "~Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useStandingsService } from "~pages/Standings/hooks/useStandingsService";

type Props = {
  standingId: string;
};

const StandingsTableActions = ({ standingId }: Props) => {
  const { deleteStanding, isDeleteStandingPending } = useStandingsService();
  const { customerId, sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const handleDelete = () => {
    modal.confirm({
      title: formatMessage({ id: "standing.delete" }),
      content: formatMessage({ id: "standing.delete.confirm" }),
      okText: formatMessage({ id: "delete" }),
      okButtonProps: { loading: isDeleteStandingPending },
      onOk: () => deleteStanding(standingId),
    });
  };

  return (
    <Space size="small">
      {contextHolder}
      <PermissionCheck permissionKeys={[PermissionNames.STANDING]} permissionOptions={[PermissionOperations.UPDATE]}>
        <StyledButton type="text" size="small">
          <Link to={`/${customerId}/admin/${sport}/${organizationId}/standings/${standingId}`}>
            <i className="fas fa-pen" />
          </Link>
        </StyledButton>
      </PermissionCheck>
      <PermissionCheck permissionKeys={[PermissionNames.STANDING]} permissionOptions={[PermissionOperations.DELETE]}>
        <StyledButton onClick={handleDelete} size="small" type="text">
          <i className="fas fa-trash" />
        </StyledButton>
      </PermissionCheck>
    </Space>
  );
};

export default StandingsTableActions;
